import { Card } from '@nextui-org/react'
import { FC, HTMLProps } from 'react'
import { useSelectTankStore } from '../../store/selectTank/useSelectTankStore'
import TankChip from './TankChip'

export const TankSelected: FC<HTMLProps<HTMLDivElement>> = ({ ...props }) => {
  const { selectedTankList, detach } = useSelectTankStore()

  return (
    <div {...props} data-testid="tank-selected-container">
      <p className="text-tdplindigo" data-testid="selected-tanks-label">
        Selected Tanks
      </p>
      <Card
        className="flex flex-row flex-wrap justify-start p-1 border border-tdpldarkgrey border-opacity-60 min-h-[3rem] w-full"
        radius="sm"
        shadow="sm"
        data-testid="selected-tanks-card"
      >
        {selectedTankList?.map((tankSelected, index) => (
          <TankChip
            key={index}
            submitTank={tankSelected}
            isActivated={false}
            onTankChipClick={() => detach(tankSelected.tankId)}
            data-testid={`selected-tank-chip-${tankSelected.tankName}`}
          />
        ))}
        {selectedTankList.length === 0 && (
          <div
            className="flex items-center justify-center text-gray-500 text-sm min-h-[2rem] w-full"
            data-testid="no-tanks-selected-placeholder"
          >
            No tanks selected
          </div>
        )}
      </Card>
    </div>
  )
}

export default TankSelected
